import * as moment from 'moment'

import { parseTime } from '../../common/dates/utils'
import { FormRecord } from './../types'

export const parseEnd = (formRecord: FormRecord): Date => {
  const endTime = parseTime(formRecord.endTime || '23:59')

  const end = formRecord.endDate
    ? moment(formRecord.endDate)
        .startOf('day')
        .add(endTime.hour, 'hours')
        .add(endTime.minute, 'minutes')
    : moment(formRecord.startDate)
        .startOf('day')
        .add(endTime.hour, 'hours')
        .add(endTime.minute, 'minutes')

  return end.toDate()
}
